import styled from 'styled-components';

export const StyleButton = styled.div`
    color: var(--color-gray-dark);
    height: 25px;
    
    .icon-button {
        background-color: var(--color-white);
        padding: 0;
        border: none;
    }
`;
